import { SixPageWrapper } from '../../components/SixPageWrapper/SixPageWrapper';
import { SixSectionWrapper } from '../../components/SixSectionWrapper/SixSectionWrapper';
import { MenuItems } from '../../types/MenuItems';
import { getTranslation } from '../../constants/translations';

import image1 from '../../assets/images/statistics/statistics_page_1.webp';
import image2 from '../../assets/images/statistics/statistics_page_2.png';
import image3 from '../../assets/images/statistics/statistics_page_3.webp';
import image4 from '../../assets/images/statistics/statistics_page_4.webp';
import image5 from '../../assets/images/statistics/statistics_page_5.webp';

import './Statistics.scss';

const images = [image1, image2, image3, image4, image5];

export const Statistics = () => {
  const style = window.getComputedStyle(document.body as HTMLElement);
  const t = getTranslation();

  return (
    <>
      <SixPageWrapper
        section={MenuItems.STATISTICS}
        title={t.STATISTICS.title}
        itemsList={t.STATISTICS.subsections.map((ss, i) => ({
          ...ss,
          link: `#${MenuItems.STATISTICS}-page-${i + 1}`,
        }))}
      />

      {t.STATISTICS.subsections.map((subsection, i) => (
        <SixSectionWrapper
          key={i}
          id={`${MenuItems.STATISTICS}-page-${i + 1}`}
          color={style.getPropertyValue('--pink')}
          imgURL={images[i]}
          title={subsection.title}
          textContent={subsection.content}
        />
      ))}
    </>
  );
};
